import { zodResolver } from '@hookform/resolvers/zod';
import {
  CoverageAssistantFilters,
  CoverageAssistantFiltersForm as CoverageAssistantFiltersFormFields,
  coverageAssistantFiltersSchema,
} from '@procureai/ui-modules-mui';
import { FormProvider, useForm } from 'react-hook-form';

import { coverageAssistantFiltersDefault } from '../../CoverageAssistantWidget.schema';
import { FormChangeDebouncer } from '~/components/FormChangeDebouncer/FormChangeDebouncer.tsx';

interface CoverageAssistantFiltersFormProps {
  initialValues?: CoverageAssistantFilters;
  onChange?: (data: CoverageAssistantFilters) => void;
}

export const CoverageAssistantFiltersForm = ({ initialValues, onChange }: CoverageAssistantFiltersFormProps) => {
  const form = useForm<CoverageAssistantFilters>({
    mode: 'onTouched',
    resolver: zodResolver(coverageAssistantFiltersSchema),
    defaultValues: initialValues ?? coverageAssistantFiltersDefault,
  });

  return (
    <FormProvider {...form}>
      <form autoComplete="off" noValidate>
        <CoverageAssistantFiltersFormFields viewOnly={false} disabled={false} />
        {onChange && <FormChangeDebouncer control={form.control} onChange={onChange} />}
      </form>
    </FormProvider>
  );
};
